// Các chuỗi tiếng Việt cho ứng dụng
export const STRINGS = {
  // Chung
  APP_NAME: 'Muzix',
  APP_DESCRIPTION: 'Hệ thống quản lý nhạc',
  
  // Navigation
  NAV_DASHBOARD: 'Bảng điều khiển',
  NAV_MUSIC: 'Nhạc',
  NAV_PLAYLISTS: 'Danh sách phát',
  NAV_SCHEDULES: 'Lịch trình',
  NAV_USERS: 'Người dùng',
  NAV_SETTINGS: 'Cài đặt',
  NAV_LOGOUT: 'Đăng xuất',
  
  // Authentication
  AUTH_LOGIN: 'Đăng nhập',
  AUTH_REGISTER: 'Đăng ký',
  AUTH_USERNAME: 'Tên đăng nhập',
  AUTH_PASSWORD: 'Mật khẩu',
  AUTH_EMAIL: 'Email',
  AUTH_CONFIRM_PASSWORD: 'Xác nhận mật khẩu',
  AUTH_FORGOT_PASSWORD: 'Quên mật khẩu?',
  AUTH_LOGIN_SUCCESS: 'Đăng nhập thành công',
  AUTH_LOGIN_ERROR: 'Đăng nhập thất bại',
  AUTH_LOGOUT_SUCCESS: 'Đăng xuất thành công',
  
  // Dashboard
  DASHBOARD_TITLE: 'Bảng điều khiển',
  DASHBOARD_TOTAL_USERS: 'Tổng số người dùng',
  DASHBOARD_TOTAL_MUSIC: 'Tổng số bài nhạc',
  DASHBOARD_TOTAL_PLAYLISTS: 'Tổng số playlist',
  DASHBOARD_TOTAL_SCHEDULES: 'Tổng số lịch trình',
  DASHBOARD_CURRENT_PLAYING: 'Đang phát',
  DASHBOARD_SYSTEM_STATUS: 'Trạng thái hệ thống',
  
  // Music
  MUSIC_TITLE: 'Quản lý nhạc',
  MUSIC_UPLOAD: 'Tải lên nhạc',
  MUSIC_UPLOAD_SUCCESS: 'Tải lên thành công',
  MUSIC_UPLOAD_ERROR: 'Tải lên thất bại',
  MUSIC_DELETE: 'Xóa',
  MUSIC_DELETE_CONFIRM: 'Bạn có chắc muốn xóa bài nhạc này?',
  MUSIC_PLAY: 'Phát',
  MUSIC_PAUSE: 'Tạm dừng',
  MUSIC_STOP: 'Dừng',
  MUSIC_ARTIST: 'Nghệ sĩ',
  MUSIC_ALBUM: 'Album',
  MUSIC_DURATION: 'Thời lượng',
  MUSIC_FILE_TYPE: 'Định dạng',
  MUSIC_SEARCH: 'Tìm kiếm nhạc...',
  
  // Playlists
  PLAYLIST_TITLE: 'Danh sách phát',
  PLAYLIST_CREATE: 'Tạo playlist mới',
  PLAYLIST_NAME: 'Tên playlist',
  PLAYLIST_DESCRIPTION: 'Mô tả',
  PLAYLIST_ADD_MUSIC: 'Thêm nhạc',
  PLAYLIST_REMOVE_MUSIC: 'Xóa khỏi playlist',
  PLAYLIST_EMPTY: 'Playlist trống',
  
  // Schedules
  SCHEDULE_TITLE: 'Lịch trình phát nhạc',
  SCHEDULE_CREATE: 'Tạo lịch trình mới',
  SCHEDULE_NAME: 'Tên lịch trình',
  SCHEDULE_START_TIME: 'Thời gian bắt đầu',
  SCHEDULE_END_TIME: 'Thời gian kết thúc',
  SCHEDULE_DAYS: 'Ngày trong tuần',
  SCHEDULE_PLAYLIST: 'Playlist',
  SCHEDULE_PRIORITY: 'Độ ưu tiên',
  SCHEDULE_ACTIVE: 'Hoạt động',
  SCHEDULE_INACTIVE: 'Không hoạt động',
  
  // Days of week
  DAYS_MONDAY: 'Thứ 2',
  DAYS_TUESDAY: 'Thứ 3',
  DAYS_WEDNESDAY: 'Thứ 4',
  DAYS_THURSDAY: 'Thứ 5',
  DAYS_FRIDAY: 'Thứ 6',
  DAYS_SATURDAY: 'Thứ 7',
  DAYS_SUNDAY: 'Chủ nhật',
  
  // Users
  USERS_TITLE: 'Quản lý người dùng',
  USERS_CREATE: 'Tạo người dùng mới',
  USERS_ROLE: 'Vai trò',
  USERS_ROLE_ADMIN: 'Quản trị viên',
  USERS_ROLE_USER: 'Người dùng',
  USERS_CREATED_AT: 'Ngày tạo',
  USERS_LAST_LOGIN: 'Đăng nhập cuối',
  
  // Player
  PLAYER_NOW_PLAYING: 'Đang phát',
  PLAYER_VOLUME: 'Âm lượng',
  PLAYER_ADMIN_CONTROLLED: 'Điều khiển bởi admin',
  PLAYER_USER_CONTROLLED: 'Điều khiển bởi người dùng',
  PLAYER_NO_MUSIC: 'Không có nhạc đang phát',
  PLAYER_SELECT_MUSIC: 'Chọn nhạc để phát',
  PLAYER_SELECT_PLAYLIST: 'Chọn playlist',
  PLAYER_MUSIC_LIST: 'Danh sách nhạc',
  PLAYER_PLAYLISTS: 'Playlists',
  PLAYER_SONGS_COUNT: 'bài hát',
  PLAYER_PLAY: 'Phát',
  PLAYER_PAUSE: 'Tạm dừng',
  PLAYER_STOP: 'Dừng',
  PLAYER_NEXT: 'Tiếp theo',
  PLAYER_PREVIOUS: 'Trước đó',
  PLAYER_SHUFFLE: 'Ngẫu nhiên',
  PLAYER_REPEAT: 'Lặp lại',
  PLAYER_REPEAT_ONE: 'Lặp lại một bài',
  PLAYER_REPEAT_ALL: 'Lặp lại tất cả',
  PLAYER_REPEAT_NONE: 'Không lặp lại',
  PLAYER_MUTE: 'Tắt tiếng',
  PLAYER_UNMUTE: 'Bật tiếng',
  PLAYER_VOLUME_PERCENT: '%',
  
  // Common actions
  ACTION_SAVE: 'Lưu',
  ACTION_CANCEL: 'Hủy',
  ACTION_DELETE: 'Xóa',
  ACTION_EDIT: 'Chỉnh sửa',
  ACTION_CREATE: 'Tạo mới',
  ACTION_UPDATE: 'Cập nhật',
  ACTION_CONFIRM: 'Xác nhận',
  ACTION_CLOSE: 'Đóng',
  ACTION_SEARCH: 'Tìm kiếm',
  ACTION_UPLOAD: 'Tải lên',
  ACTION_DOWNLOAD: 'Tải xuống',
  
  // Messages
  MSG_SUCCESS: 'Thành công',
  MSG_ERROR: 'Có lỗi xảy ra',
  MSG_LOADING: 'Đang tải...',
  MSG_NO_DATA: 'Không có dữ liệu',
  MSG_CONFIRM_DELETE: 'Bạn có chắc muốn xóa?',
  MSG_UNSAVED_CHANGES: 'Có thay đổi chưa được lưu',
  
  // File upload
  UPLOAD_DRAG_DROP: 'Kéo thả file vào đây hoặc nhấp để chọn',
  UPLOAD_SUPPORTED_FORMATS: 'Hỗ trợ: MP3, WAV, FLAC, M4A, OGG',
  UPLOAD_MAX_SIZE: 'Kích thước tối đa: 50MB',
  UPLOAD_PROGRESS: 'Đang tải lên...',
  
  // Time
  TIME_HOUR: 'Giờ',
  TIME_MINUTE: 'Phút',
  TIME_SECOND: 'Giây',
  TIME_AM: 'SA',
  TIME_PM: 'CH',
  
  // Status
  STATUS_ONLINE: 'Trực tuyến',
  STATUS_OFFLINE: 'Ngoại tuyến',
  STATUS_CONNECTING: 'Đang kết nối',
  STATUS_CONNECTED: 'Đã kết nối',
  STATUS_DISCONNECTED: 'Mất kết nối',
};

export default STRINGS;
